import React from 'react';
import Link from 'gatsby-link';

import Markdown from 'react-remarkable';

const content = `
## Why you should trust us?



## Clarifying the goal: what does it mean to find a partner?
For each of our goals, we like to clarify what achieving it or making progress looks like. For
finding a partner, the ultimate goal for most people, is to enter into a stable relationship,
that they regard as being highly fulfilling. In the short-term, progress can take many forms. One sign in the very short term, is more matches on dating apps like Tinder. In the medium term, a sign is that you start going on more dates, and these dates tend to lead to second dates and so on.

## The most promising path
We think that for most people, the most promising path for finding a partner, is to focus on **fitness**, **attire**, and optimizing your **online dating profiles**.

### Attire

Depending on where you are starting out, revamping your attire can be one of the easiest and highest return changes you can make. Namely, choosing well-fitting clothes, whose style is common and inoffensive. We turn to our friends at Reddit, for an exploration
Fashion is a domain unto itself. Over time, as you gr

https://www.reddit.com/r/malefashionadvice/comments/5da1xt/building_a_basic_wardrobe_v60/

### Fitness


### Online dating



## Other paths and their tradeoffs



## Tracking your progress

In this next section, we'll explain what you can track, to better understand your progress on this goal. For more help tracking and for access to software designed specifically to track this goal, check out our [premium program](/our-process).

### Lead measures

#### Fitness



#### Online dating matches


### Lag measures

#### Successful dates

Over time, following these steps, should increase the number of successful dates you go on.


`;

const IndexPage = () => (
  <div>
    <div className="mw9 center">
      <h1 className="">Find a partner</h1>
      <div className="cf">
        <div className="pa3 mv3 mw7 center" style={{ outline: '1px solid #484848' }}>
          <div className="tc">
            <h3>Is finding a partner important to you?</h3>
            <p className="i">Get world-class help in achieving your goals</p>
            <div className="tl">
              <p>
                The content that follows has been compiled by a dedicated team of researchers,
                through in-depth research and extensive consultation with experts. We believe that
                it alone can get you started on the rewarding path of achieving this goal.
              </p>
              <p>
                But goals are difficult to achieve alone. That's why we offer a{' '}
                <b>premium program</b>, that{' '}
                <b>
                  combines the best of face-to-face expert guidance and cutting edge technology &
                  software
                </b>. We do this, to create a program personalized for you and to help you track
                your progress and stay motivated.
              </p>

              <p>
                Our track record is stellar.{' '}
                <b>
                  75% of users who enroll in our program for this goal, find a partner within a
                  year, who they report being extremely satisifed with
                </b>. 50% of users report doing so within 3 months.
              </p>
            </div>
            <Link to="/our-process" className="f6 link dim ph3 pv2 mb2 dib white bg-black w-75 tc">
              Learn more about our program
            </Link>
          </div>
        </div>
      </div>
      <Markdown>{content}</Markdown>
    </div>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/goals/find-a-partner.js